
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guest-policy",
      function () {
        return require("private-next-pages/guest-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guest-policy"])
      });
    }
  